"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROUP_CHAT_CUSTOM_REACTIONS = exports.CHAT_REACTIONS_TRANSITION_DATE = exports.CHAT_REACTIONS_LIST_SIZE_SETTING = void 0;
var GROUP_CHAT_CUSTOM_REACTIONS = [{
  colons: ':thumbsup:',
  emoticons: [],
  id: 'thumbsup',
  name: 'Thumbs Up',
  native: '👍',
  skin: null,
  unified: '1f44d'
}, {
  colons: ':green_heart:',
  emoticons: [],
  id: 'green_heart',
  name: 'Green heart',
  native: '💚',
  skin: null,
  unified: '1f49a'
}, {
  colons: ':clap:',
  emoticons: [],
  id: 'clap',
  name: 'Clapping hands',
  native: '👏',
  skin: null,
  unified: '1f44f'
}, {
  colons: ':busts_in_silhouette:',
  emoticons: [],
  id: 'busts_in_silhouette',
  name: 'People hugging',
  native: '👥',
  skin: null,
  unified: '1f465'
}, {
  colons: ':tada:',
  emoticons: [],
  id: 'tada',
  name: 'Celebration',
  native: '🎉',
  skin: null,
  unified: '1f389'
}, {
  colons: ':hugging_face:',
  emoticons: [],
  id: 'hugging_face',
  name: 'Hugging face',
  native: '🤗',
  skin: null,
  unified: '1f917'
}];
exports.GROUP_CHAT_CUSTOM_REACTIONS = GROUP_CHAT_CUSTOM_REACTIONS;
var CHAT_REACTIONS_TRANSITION_DATE = new Date(process.env.REACT_APP_CHAT_REACTIONS_TRANSITION_DATE);
exports.CHAT_REACTIONS_TRANSITION_DATE = CHAT_REACTIONS_TRANSITION_DATE;
var CHAT_REACTIONS_LIST_SIZE_SETTING = {
  size: 20
};
exports.CHAT_REACTIONS_LIST_SIZE_SETTING = CHAT_REACTIONS_LIST_SIZE_SETTING;